(function ($) {
    $.fn.agenceconseiller = function () {

        return this.each(function () {
            var myAgenceconseiller = $(this);
            var cache = {};
            var src = myAgenceconseiller.data('src');
            var departement = '[name=' + myAgenceconseiller.data('departement').replace(/\[/, '\\\[').replace(/\]/, '\\\]') + ']';
            var type = '[name=' + myAgenceconseiller.data('type') + ']';
            var appartenance = myAgenceconseiller.data('appartenance');

            $(myAgenceconseiller).bind('refresh', function (event) {

                var id = $(departement).val() + '_' + $(type + ':checked').val()+'_'+appartenance;

                $(myAgenceconseiller)
                    .html(cache[id])
                    .change();

            });

            $(departement).bind('change', function (event) {

                var id = $(departement).val() + '_' + $(type + ':checked').val() +'_'+ appartenance;

                if (id in cache) {
                    $(myAgenceconseiller).trigger('refresh');
                    return;
                }

                $.ajax({
                    url: src,
                    type: 'post',
                    data: {'departement': $(this).val(), 'type': $(type + ':checked').val(), 'appartenance': appartenance},
                    dataType: 'html',
                    beforeSend:function(){
                        $(myAgenceconseiller).addClass('ui-autocomplete-loading');
                    },
                    complete:function(){
                        $(myAgenceconseiller).removeClass('ui-autocomplete-loading');
                    },
                    success: function (data) {
                        cache[id] = data;
                        $(myAgenceconseiller).trigger('refresh');
                    }
                });
            });

            $(type).bind('change', function (event) {
                $(departement).trigger('change');
            });

            return myAgenceconseiller;
        });
    };

}(jQuery));
